import { FirebaseAuth } from '../../../../lib/firebase'

export const emailPasswordSignUp = (
  email: string,
  password: string
): Promise<any> => FirebaseAuth.createUserWithEmailAndPassword(email, password)
